import { IBrief } from "@shared/lib/types/brief";
import { Button, Tag, Typography } from "@shared/ui";
import { ColumnsType } from "antd/es/table";
import { ChevronRight } from "lucide-react";
import { NavigateFunction } from "react-router-dom";
import styles from "../ui/MyPricing.module.scss";
import { formatAssignedTimeline } from "./utils/formatters";
import { getMyPricingProjectPath } from "./utils/routes";

const { Text } = Typography;

export function getMyPricingBriefColumns(
  activeUserId: string,
  navigate: NavigateFunction
): ColumnsType<IBrief> {
  return [
    {
      title: "Project",
      key: "project",
      render: (_, record) => <Text>{record.name}</Text>,
    },
    {
      title: "Brand",
      key: "brand",
      render: (_, record) => (
        <div className={styles.brandCell}>
          <Tag className={styles.brandTag}>
            {record?.brand?.name?.[0] ?? "—"}
          </Tag>
          <Text>{record?.brand?.name}</Text>
        </div>
      ),
    },
    // {
    //   title: "Creators",
    //   key: "creators",
    //   render: (_, record) => record?.totalInfluencerCount,
    // },
    {
      title: "Account Manager",
      key: "accountManager",
      render: (_, record) => (
        <div className={styles.accountManagerList}>
          {record.accountManagers?.map((manager) => (
            <Tag key={manager._id} className={styles.accountManagerTag}>
              {manager.firstName} {manager.lastName}
            </Tag>
          ))}
        </div>
      ),
    },
    {
      title: "Assigned Timeline",
      key: "assignedTimeline",
      render: (_, record) => (
        <Text>
          {formatAssignedTimeline(
            record?.myPricingTracker?.[0]?.deadlineFrom,
            record?.myPricingTracker?.[0]?.deadlineTo
          )}
        </Text>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button
          type="link"
          icon={<ChevronRight size={16} />}
          iconPosition="end"
          onClick={() =>
            navigate(getMyPricingProjectPath(record._id, activeUserId))
          }
        >
          Open Project
        </Button>
      ),
    },
  ];
}
